import React from 'react';
import DV360Analytics from './BotAnalytics';
import Header from '../template/Header';

function ChatBot() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <Header />
      
      <DV360Analytics />
    </div>
  );
}

export default ChatBot;